export const centerContent: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "20px",
};

export const calculator: React.CSSProperties = {
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  backgroundColor: "#fdfdfd",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  width: "100%",
  maxWidth: "600px",
  margin: "0 auto",
};

export const title: React.CSSProperties = {
  color: "#e6261d",
};

export const inputLabel: React.CSSProperties = {
  color: "#3b4773",
};

export const item: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
};

export const select: React.CSSProperties = {
  width: "100%",
  padding: "8px 12px",
  fontSize: "16px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  backgroundColor: "#fff",
  color: "#3b4773",
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  cursor: "pointer",
};

export const submitButton: React.CSSProperties = {
  backgroundColor: "#e6261d",
  color: "#fff",
  padding: "10px 20px",
  border: "none",
  borderRadius: "24px",
  cursor: "pointer",
  fontSize: "16px",
  transition: "background-color 0.3s ease",
  alignItems: "center",
};

export const line: React.CSSProperties = {
  width: "100%",
  height: "2px",
  backgroundColor: "#e6261d",
  margin: "4px 0",
};

export const gridLabel: React.CSSProperties = {
  height: "70px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#e6261d",
  fontWeight: "bold",
  fontSize: "16px",
};

export const label: React.CSSProperties = {
  color: "#3b4773",
};

export const value: React.CSSProperties = {
  textAlign: "center",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  flexGrow: 1,
  paddingTop: "4px",
};

export const results: React.CSSProperties = {
  marginTop: "20px",
  padding: "10px",
  border: "3px solid #e6261d",
  borderRadius: "25px",
};

export const inputGroup: React.CSSProperties = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  width: "100%",
  border: "1px solid #ccc",
  borderRadius: "4px",
  overflow: "hidden",
};

export const inputWithUnit: React.CSSProperties = {
  flex: "1",
  padding: "8px 60px 8px 12px",
  border: "none",
  outline: "none",
  fontSize: "16px",
  textAlign: "right",
};

export const unit: React.CSSProperties = {
  position: "absolute",
  right: "0",
  top: "0",
  bottom: "0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "50px",
  borderLeft: "1px solid #ccc",
  fontSize: "16px",
  pointerEvents: "none",
};

export const inputField: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr 3fr",
  gap: "0.5rem",
  marginBottom: "1rem",
};

export const hubspotFormContact: React.CSSProperties = {
  display: "none",
};

export const inputDefault: React.CSSProperties = {
  padding: "8px 12px",
  border: "1px solid #ccc",
  outline: "none",
  fontSize: "16px",
  textAlign: "left",
  borderRadius: "4px",
};

export const resultsGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
  gap: "1rem",
  marginTop: "1rem",
  marginBottom: "1rem",
  alignItems: "start", // items align top so values can grow independently
};

export default {
  inputLabel,
  select,
  calculator,
  submitButton,
  title,
  unit,
  inputField,
  inputGroup,
  results,
  value,
  gridLabel,
  line,
  item,
  centerContent,
  resultsGridStyle,
  label,
  inputWithUnit,
  hubspotFormContact,
  inputDefault,
};
